    export function encodeBase64(str) {
        let encoded = btoa(unescape(encodeURIComponent(str)));
        // Remove any '=' padding characters from the end
        return encoded.replace(/=*$/, '');
    }

    export function decodeBase64(str) {
        // Add back any missing padding for correct Base64 decoding
        let padding = str.length % 4 === 2 ? '==' : (str.length % 4 === 3 ? '=' : '');
        return decodeURIComponent(escape(atob(str + padding)));
    }